interface DisplayMetricCardProps {
    value: number | null | undefined;
    metricName: string;
    unitDescriptor?: string;
    icon: string;
}

const DisplayMetricCard = ({
    value,
    metricName,
    unitDescriptor,
    icon,
}: DisplayMetricCardProps) => {
    const formattedValue =
        value == null
            ? "—"
            : Number(value).toLocaleString();

    return (
        <div className="relative overflow-hidden rounded-xl border bg-white transition-all group hover:shadow-lg">
            <div className="p-3">
                <div className="mb-1 flex items-start justify-between">
                    <div className="flex items-center gap-2">
                        <div className="flex-shrink-0 rounded-lg bg-gresham-slate/10 p-2 transition-colors group-hover:bg-gresham-slate/20">
                            <img
                                src={icon}
                                alt=""
                                aria-hidden="true"
                                className="h-8 w-8"
                            />
                        </div>

                        <span className="text-[1.75rem] font-semibold leading-none">
                            {formattedValue}
                        </span>
                    </div>
                </div>

                <div className="space-y-0.5">
                    <h3 className="text-sm font-semibold text-port-text">
                        {metricName}
                    </h3>

                    {unitDescriptor && (
                        <p className="text-xs leading-tight text-port-text">
                            {unitDescriptor}
                        </p>
                    )}
                </div>
            </div>

            <div className="absolute bottom-0 left-0 right-0 h-1 bg-gradient-to-r from-[#2258e5]/50 to-[#00ac4e]/50 opacity-0 transition-opacity group-hover:opacity-100" />
        </div>
    );
};

export default DisplayMetricCard;